(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name greatCircleDistance.controller:GreatCircleDistanceCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('greatCircleDistance')
		.controller('GreatCircleDistanceCtrl', GreatCircleDistanceCtrl);

	function GreatCircleDistanceCtrl(CommonMasterData, PopupManager, EventManagerService, GreatCircleDistanceService, MessageService, $timeout, $window) {
		var vm = this;
		var rowHeight = 50;
		vm.showRightPanel = false;
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				origin : {value : undefined, required:false},
                destination : {value : undefined, required:false},
                pageSize : Math.ceil(screen.height / rowHeight) * 3,
				startPosition : 1,
			},
			masterList : {
				airportList : [],
				// 70 (title bar height) + 40 (toolbar height)+ 47 (table header)
				canvasHeight : $window.innerHeight - 157,
				//70 (Side panel)
				canvasWidth : $window.innerWidth - 70
			},
			distanceData : []
		};

		angular.element($window).bind('resize', function(){
            $timeout(function () {
            	vm.model.masterList.canvasHeight = $window.innerHeight - 157;
            	vm.model.masterList.canvasWidth = $window.innerWidth - 70;
            },0);
        });

		EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);
		EventManagerService.registerEventListener(EventManagerService.EVENT.DO_REFRESH, updateDistanceList);

		// to hide and show search panel
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
		};

		vm.submitSearch = function(searchParams) {
			//To reset the scroll to top after the first search.
			document.querySelector('.great-circle-elastic-div').scrollTop = 0;
			vm.model.searchCriteria = searchParams;
			vm.model.searchCriteria.startPosition = 1;
			getDistanceList();
		};

		vm.clickOnAction = function(selectedRowData, flag) {
			if(flag == "EDIT") {
				selectedRowData.airportList = vm.model.masterList.airportList;
                PopupManager.openModal('ADD_EDIT_DISTANCE', selectedRowData);
			} else if(flag == "DELETE") {
				onDeleteAction(selectedRowData);
			}
		};

    vm.change = function ($event,flag, selectedItems, value) {
      if(flag ==='matchingIndex'){
        setMatchingIndexForAirports(value);
      }
    }

    function setMatchingIndexForAirports(viewValue){
      if(viewValue !== " " && viewValue!== null) {
        angular.forEach(vm.model.masterList.airportList, function(apt) {
          apt.matchingIndex = apt.airPortCode.toLowerCase().indexOf(viewValue.toLowerCase());
        })
      }
    }

		vm.clickOnAddDistance = function() {
			vm.model.searchPanelToggle = false;
			var modalParams = {};
			modalParams.airportList = vm.model.masterList.airportList;
			PopupManager.openModal('ADD_EDIT_DISTANCE', modalParams);
		};

		function updateDistanceList(objectData) {
			if(objectData.action == "EDIT") {
				var indexToUpdate = _.findIndex(vm.model.distanceData.gridDistanceList, {gridCircleId: objectData.param.gridCircleId});
				objectData.param.distance = parseInt(objectData.param.distance);
				vm.model.distanceData.gridDistanceList[indexToUpdate] = objectData.param;
			} else if(objectData.action == "ADD" && vm.model.distanceData.length != 0) {
				vm.submitSearch(vm.model.searchCriteria);
			} else if(objectData.action == "DELETE") {
				var indexToUpdate = _.findIndex(vm.model.distanceData.gridDistanceList, {gridCircleId: objectData.param.gridCircleId});
				vm.model.distanceData.gridDistanceList.splice(indexToUpdate, 1);
			}
		}

		// load grid data
		function getDistanceList() {
			GreatCircleDistanceService.searchGridCircularDistance(vm.model.searchCriteria, function(distanceData) {
				vm.model.distanceData = distanceData;
				vm.model.searchPanelToggle = false;
			}, function(error) {
				MessageService.error(error);
			});
		};

		function getNextSetOfRecords() {
			if (vm.model.distanceData &&
	                vm.model.distanceData.totalRecords &&
	                vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize < vm.model.distanceData.totalRecords
	            ) {
	                vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize;
	                getDataForElasticSearch();
	            }
			else {
				var lastPageStartPos = vm.model.distanceData.totalRecords - vm.model.searchCriteria.pageSize;
                if (vm.model.searchCriteria.startPosition < lastPageStartPos) {
                    vm.model.searchCriteria.startPosition = lastPageStartPos;
                    getDataForElasticSearch();
                }
			}
		}

		function getDataForElasticSearch() {
			GreatCircleDistanceService.searchGridCircularDistance(vm.model.searchCriteria, function(newDistanceList) {
				GreatCircleDistanceService.appendToGridDistanceList(vm.model.distanceData, newDistanceList);
			}, function(error) {
				MessageService.error(error);
			});

		}

		function onDeleteAction(selectedRowData) {
             var details = {
                 title: 'Confirmation',
                 messages: ['Selected record will be Deleted. Do you wish to Continue?']

             };
             PopupManager.openModal('CONFIRM_DIALOG', details, function(param){
            	 if (!!param) {
	            	var searchParams = {"gridCircleId" : selectedRowData.gridCircleId};
	            	GreatCircleDistanceService.deleteGridCircularDistance(searchParams , function(response) {
	            		if(response.success) {
	            			MessageService.success('Selected record deleted Successfully');
	            		}
	     			}, function(error) {
	     				MessageService.error(error);
	     			});
            	}
             });
        }

		// get master data list
		(function() {

			// Origing and destination list
			CommonMasterData.getAirportList(function (airportList) {
                vm.model.masterList.airportList = airportList;
            }, function (error) {})

		})();
	}
}());
